'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BeautifulButton = exports.LoadingSpinner = undefined;
var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');
var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  position: absolute;\n  left: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n'], ['\n  position: absolute;\n  left: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n']),
  _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  ', '\n  ', '\n  min-width: 120px;\n  border-width: 0px;\n  border-radius: 24px;\n  background-color: #f78323;\n  color: #fff;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  position: relative;\n\n  &:hover {\n    background-color: ', ';\n  }\n\n  ', '\n\n  ', '\n\n  ', '\n'], ['\n  ', '\n  ', '\n  min-width: 120px;\n  border-width: 0px;\n  border-radius: 24px;\n  background-color: #f78323;\n  color: #fff;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  position: relative;\n\n  &:hover {\n    background-color: ', ';\n  }\n\n  ', '\n\n  ', '\n\n  ', '\n']);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _index = require('../Spinner/index');
var _index2 = _interopRequireDefault(_index);
var _fontSize = require('../../../behaviors/fontSize');
var _height = require('../../../behaviors/height');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var LoadingSpinner = (0, _styledComponents2.default)(_index2.default)(_templateObject);
var BeautifulButton = _styledComponents2.default.button(_templateObject2, _fontSize.withButtonSize, _height.withButtonHeight, function (props) {
  return props.outline ? 'rgba(0,0,0,0.025)' : '#f99d53';
}, function (props) {
  return props.fluid && '\n    width: 100%;\n    padding: 0 8px;\n  ';
}, function (props) {
  return props.outline && '\n    background: transparent;\n    color: #f78323;\n    border: 1px solid;\n  ';
}, function (props) {
  return props.disabled && '\n    opacity: 0.6;\n    cursor: not-allowed;\n  ';
});
exports.LoadingSpinner = LoadingSpinner;
exports.BeautifulButton = BeautifulButton;